export default "__VITE_ASSET__vnbhQ0Y5__"